// Exact disclaimer text shown next to the SMS opt-in checkbox in both the
// post-generation phone prompt (ForYouPage) and the account-settings phone
// editor (MePage). Sent to the server on save so we keep an audit record of
// *which* language the user agreed to — TCPA / A2P 10DLC requires we can
// prove express written consent if a carrier or the FCC asks.
//
// Required disclaimers, all present below:
//   • use case + brand: "recurring SMS clip-ready alerts and marketing texts from Clipbait"
//   • marketing use case: "You are opting into marketing texts"
//   • message frequency may vary
//   • standard message and data rates may apply
//   • Reply STOP to opt out
//   • Reply HELP for help
//   • we will not share mobile information with third parties for promotional or marketing purposes
//
// If the wording changes, the existing per-user `smsConsentLanguage` field on
// the User document continues to reflect the older version they agreed to —
// don't backfill it.
export const SMS_CONSENT_LANGUAGE =
  "By checking this box, I agree to receive recurring SMS clip-ready alerts " +
  "and marketing texts from Clipbait at the number above. You are opting " +
  "into marketing texts. Message frequency may vary. Standard message and " +
  "data rates may apply. Reply STOP to opt out. Reply HELP for help. We " +
  "will not share your mobile information with third parties for " +
  "promotional or marketing purposes.";
